import React, { useState, useEffect } from 'react';

import { useMessages } from '../hooks/useMessages';
import ListMessages from '../components/widget/ListMessages';
import Search from '../components/html/Search';
import * as Util from '../data/General';
import { is } from 'date-fns/locale';


function Messages(props) {
  const [selected, setSelected] = useState(null);
  const [idElement, setIdElement] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  
  const {data, isLoad, searchText, incrementPage, clear, setNewFilter, filter, setInbox, isInbox} = useMessages({ method:"GET"})
  
  useEffect(() => {
    if(data && data.length > 0 && selected === null){
      setSelectedElement(data[0]);
      markasread(data[0].conversationId ? data[0].conversationId : data[0].id);
    }
    return () => {
      clear();
    }
  },[data]);

  const setSelectedElement = (item) => {
    setSelected(item.conversationId ? item.conversationId : item.id); 
    setSelectedData(item); 
    setIdElement(item.conversationId ? item.id : null)
  }

  const getDate = (varDate) =>{
    if(varDate && typeof varDate === 'string'){
      let arr = varDate.split("T");
      let day = arr[1].split("-");
      let min = day[0].split(":");
      return arr[0];
      
    }
    return "";
  }
  
  const firstLetter = (str) => {
    if (str === null || str.length === 0) {
      return "N"; // Handle empty strings
    }
    return str.charAt(0).toUpperCase();
  }

  const addCount = () =>{
    if(!isLoad){
      incrementPage();
    }
  }

  const searchFinish = (text) =>{
    searchText(text);
  }

  const setClear = () => {
    searchText("");
  }

  useEffect(() => {
    if(data && data.length > 0 && selected !== null && selectedData.inbox && selectedData.inbox > 0){
      markasread(selected);
    }
  },[selected]);

  const markasread = (str) => {
    console.log("markasread",str);
    setInbox(str);
    Util.callServer(dataOk, dataOk, `inboxs/conversations/${str}/markasread`,{}, "POST");
  }

  const dataOk = (data) => {
  }

 
  return (
    <div className='messages'>
      <div className='messages-list'>
        <Search searchFinish={searchFinish} clear={setClear}/>
        <div className='content-filter-messages'>
            <div className={filter === "unread" ? 'active' : ''} onClick={() => setNewFilter("unread")}>
              No leídos
            </div>
            <div className={filter === "all" ? 'active' : ''} onClick={() => setNewFilter("all")}>
              Todos
            </div>
        </div>
        <ul>
          {isLoad ? <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div> : null}
          {data && data.length > 0 && data.map((item) => (
            <li key={item.id} className={selected === item.id ? "selected" : ""} onClick={() => {setSelectedElement(item)}}>
              <div className='img'>{firstLetter(item.contact.firstName)}{firstLetter(item.contact.lastName)}</div>
              <div className='content'>
                <span>{item.contact.firstName} {item.contact.lastName}</span>
                <span>{item.mediaContentType === "image/jpeg" ? "Imagen" : item.mediaContentType === "audio/ogg" ? "Audio" : item.body}</span>
              </div>
              <div className='date'>{getDate(item.updatedAt)}</div>
              {isInbox(item) ? <div className='inbox'>{item.inbox}</div> : null}
            </li>
          ))}
        </ul>
        {data ? <div className={`more ${isLoad ? "opacity-60" : ""}`} onClick={() => {addCount()}}>Mas</div> : null}
      </div>
      {selected ? (
        <div className='messages-content'>
          <div className='messages-header'>
            <div className='messages-list'>
              <ul>
                <li>
                  <div className='img'>{firstLetter(selectedData.contact.firstName)}{firstLetter(selectedData.contact.lastName)}</div>
                  <div className='content'>
                    <span>{selectedData.contact.firstName} {selectedData.contact.lastName}</span>
                    <span><a href={`https://wa.me/${selectedData.contact.phone}`} target="_blank">{selectedData.contact.phone}</a></span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          {<ListMessages idMessage={selected} idElement={idElement}/>}
        </div>
      ) : <div></div>}
    </div>
);
}

export default Messages;